// The partner agreement version currently in force.
//
// This MUST stay in lockstep with the backend's CURRENT_AGREEMENT_VERSION
// (myhoom_backend_api/src/routes/business.py): the server records acceptance under this
// version and gates business creation on it. When legal revises the agreement, bump this
// value, the agreement text in partnerAgreement.js, and the backend constant together — a
// new version is a new, separately recorded acceptance.
export const AGREEMENT_VERSION = "v1.2";
